module.exports = __webpack_public_path__ + "img/3.cca818e2.png";